import React from "react";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import Project from "./Project";
import Error from "./ui/Error";
import Loading from "./ui/Loading";

export default function ProjectsList() {
  const { data: projects, isLoading, isError, error } = useGetProjectsQuery();

  // deciding what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && projects?.length === 0) {
    content = <div>No projects found!</div>;
  } else if (!isLoading && !isError && projects?.length > 0) {
    content = projects.map((project) => {
      return <Project key={project.id} project={project} />;
    });
  }
  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
